import styled from '@emotion/styled'

/** Prevents Samsung Internet / Android forced dark mode from inverting QR and light UI surfaces. */
const lightModeSurfaceStyles = `
  color-scheme: light only;
  isolation: isolate;
  forced-color-adjust: none;
`

export const QrExpandedOverlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 1200;
  background: rgba(0, 0, 0, 0.92);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: max(24px, env(safe-area-inset-top)) max(24px, env(safe-area-inset-right))
    max(24px, env(safe-area-inset-bottom)) max(24px, env(safe-area-inset-left));
  box-sizing: border-box;

  @media (max-width: 768px) {
    padding: max(16px, env(safe-area-inset-top)) max(12px, env(safe-area-inset-right))
      max(16px, env(safe-area-inset-bottom)) max(12px, env(safe-area-inset-left));
  }
`

export const QrExpandedContent = styled.div`
  background: #ffffff;
  padding: 32px;
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  max-width: min(92vw, 500px);
  width: 100%;
  position: relative;
  box-sizing: border-box;
  ${lightModeSurfaceStyles}

  @media (max-width: 768px) {
    padding: 20px 16px;
    max-width: min(96vw, 420px);
    gap: 12px;
  }
`

export const QrExpandedInstruction = styled.div`
  width: 100%;
  text-align: center;
  box-sizing: border-box;
  padding-inline-end: 44px;
`

export const QrExpandedCloseButton = styled.button`
  position: absolute;
  top: 12px;
  right: 12px;
  min-width: 44px;
  min-height: 44px;
  width: 44px;
  height: 44px;
  border: none;
  background: #f3f4f6;
  border-radius: 8px;
  cursor: pointer;
  font-size: 20px;
  line-height: 1;
  color: #6b7280;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
`

export const QrExpandedTitle = styled.div`
  font-size: 18px;
  font-weight: 600;
  color: #1f2937;
  text-align: center;
  padding: 0 40px;

  @media (max-width: 768px) {
    font-size: 16px;
  }
`

export const QrPaymentPendingBadge = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border-radius: 999px;
  font-size: 13px;
  font-weight: 600;
  background: rgba(251, 191, 36, 0.15);
  color: #b45309;

  &::before {
    content: '';
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: currentColor;
    opacity: 0.85;
  }
`

export const QrExpandedNotice = styled.div`
  font-size: 14px;
  color: #6b7280;
  text-align: center;
  line-height: 1.4;
  max-width: 280px;
`

export const QrExpandedQrWrapper = styled.div`
  background: #ffffff;
  padding: 24px;
  border-radius: 12px;
  display: flex;
  justify-content: center;
  width: 100%;
  box-sizing: border-box;
  ${lightModeSurfaceStyles}

  & svg {
    display: block;
    forced-color-adjust: none;
  }

  & img {
    display: block;
    forced-color-adjust: none;
  }
`
